import { makeStyles } from "@mui/styles";
export default makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
}));
